import { INITIAL, PENDING, COMPLETED, FAILED } from "engine/modules/constants"
import {
  READ_PLAN_EVENTS_LIST,
  READ_PLAN_EVENTS_LIST_SUCCEEDED,
  READ_PLAN_EVENTS_LIST_FAILED,
} from "../actions/types"

export const INITIAL_STATE = {
  planEvents: {
    status: INITIAL,
    data: [],
    count: 0,
  },
}

export default function notificationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // read list
    case READ_PLAN_EVENTS_LIST:
      return {
        ...state,
        planEvents: {
          ...state.planEvents,
          status: PENDING,
        },
      }
    case READ_PLAN_EVENTS_LIST_SUCCEEDED: {
      return {
        ...state,
        planEvents: {
          status: COMPLETED,
          data: action.response.data,
          count: action.response.totalCount,
        },
      }
    }
    case READ_PLAN_EVENTS_LIST_FAILED:
      return {
        ...state,
        planEvents: {
          ...state.planEvents,
          status: FAILED,
        },
      }
    default:
      return state
  }
}
